export default (
  state = {
    data: [],
    selectedTrainingType: "registered",
    error: null,
  },
  action
) => {
  switch (action.type) {
    case "GET_TRAININGS_SUCCESS":
      return {
        ...state,
        data: action.payload.data,
        error: null,
      };
    case "GET_TRAININGS_ERROR":
      return {
        data: [],
        selectedTrainingType: action.selectedTrainingType,
        error: action.payload,
      };
    case "CHANGE_SELECTED_TRAINING_TYPE":
      return { ...state, selectedTrainingType: action.payload };
    // case "GET_TRAINING_DETAIL_SUCCESS":
    //   return { ...state, data: action.payload };
    // case "GET_TRAINING_DETAIL_ERROR":
    //   return { data: [], error: action.payload };

    default:
      return state;
  }
};
